module.exports = __webpack_public_path__ + "img/company-intro-bar-mini.3997922.png";